import { render, staticRenderFns } from "./personal-coverage-refer-form.vue?vue&type=template&id=478a0105&scoped=true&"
import script from "./personal-coverage-refer-form.vue?vue&type=script&lang=js&"
export * from "./personal-coverage-refer-form.vue?vue&type=script&lang=js&"
import style0 from "./personal-coverage-refer-form.vue?vue&type=style&index=0&id=478a0105&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a0105",
  null
  
)

export default component.exports